import { VALUE_NONE } from './UtilsLogic';
export const loadImage = (src: string): Promise<HTMLImageElement> => {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => resolve(img);
		img.onerror = (e) => reject(e);
		img.crossOrigin = 'Anonymous';
		img.src = src;
	});
};

export function downloadURI(uri: string, name: string) {
	var link = document.createElement('a');
	link.download = name;
	link.href = uri;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

export const getFileDataFromEvent = (e: Event): File | typeof VALUE_NONE => {
	const target = e.currentTarget as HTMLInputElement;
	if (!target || !target.files) {
		return VALUE_NONE;
	}
	// ファイル情報を取得
	return target.files[0];
};

export const readFileAsDataUrl = (
	file: File,
	call: (base64: string) => any,
) => {
	const reader = new FileReader();
	// ファイル読み込みに成功したときの処理
	reader.onload = function () {
		const base = reader.result;
		if (typeof base !== 'string') {
			return;
		}

		call(base);
	};
	// ファイル読み込みを実行
	reader.readAsDataURL(file);
};

export const copyTextToClipboard = (text: string) => {
	navigator.clipboard.writeText(text).then(
		function () {
			//console.log('Async: Copying to clipboard was successful!');
		},
		function (err) {
			//console.error('Async: Could not copy text: ', err);
		},
	);
};
